// Config panel for the "check_controller_online" condition block
import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  FormHelperText
} from '@mui/material';
import { qbusApi } from '../../../services/apiClient';

const CheckControllerOnlineConfig = ({ config, locationId, onChange, onSummaryChange }) => {
  const [controllers, setControllers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!locationId) return;
    setLoading(true);
    qbusApi.getControllersForLocation(locationId)
      .then((res) => setControllers(res.data.controllers || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [locationId]);

  const handleChange = (value) => {
    const updated = { ...config, controllerId: value };
    onChange(updated);
    const ctrl = controllers.find((c) => c.id === value);
    const name = ctrl?.friendlyName || ctrl?.name || `#${value}`;
    onSummaryChange(`${name} online?`);
  };

  if (loading) return <CircularProgress size={24} />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Checks if a Qbus controller is currently online (monitoring_status = ok).
        Branches true if online, false if offline.
      </Typography>

      <FormControl fullWidth size="small" required>
        <InputLabel>Controller</InputLabel>
        <Select
          value={config.controllerId || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Controller"
        >
          {controllers.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.friendlyName || c.name} ({c.serialNumber || c.id})
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>The Qbus controller to check</FormHelperText>
      </FormControl>
    </Box>
  );
};

export default CheckControllerOnlineConfig;
